import DisciplineSettings from './DisciplineSettings';

export default DisciplineSettings;



